import { KitchenDisplay, KitchenDisplayApi, Store, StoreApi } from 'kiolyn-api';
import IKitchenDisplayRepository from '../domain/repositories/IKitchenDisplayRepository';

export class KitchenDisplayRepository implements IKitchenDisplayRepository {
  private readonly api: KitchenDisplayApi;
  private readonly storeAPI: StoreApi;

  constructor(basePath: string) {
    this.api = new KitchenDisplayApi({
      basePath
    });
    this.storeAPI = new StoreApi({
      basePath
    });
  }

  public async listKitchenDisplay(storeid: string): Promise<KitchenDisplay[]> {
    const r = await this.api.listDSKitchenDisplays(storeid);
    return r.data;
  }

  public async loadKitchenDisplay(
    storeid: string,
    kitchenDisplayId: string
  ): Promise<KitchenDisplay | undefined> {
    const r = await this.api.loadDSKitchenDisplay(storeid, kitchenDisplayId);
    return r.data as KitchenDisplay;
  }

  public async loadStore(storeid: string): Promise<Store | undefined> {
    const r = await this.storeAPI.loadStore(storeid);
    return r.data.value;
  }
}
